// generated from 321_830 samples

import { z } from "zod";
import { triggerFiltersGetSchema } from "./triggerFiltersGetSchema";

export const performedCustomEventWithNestedObjectTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::PerformedCustomEventWithNestedObject"),
  // null: 22_245 (6.91%)
  // true 448 (0.15%), false 299_137 (99.85%)
  blocklisted: z.boolean().nullable().optional(),
  // null: 1_338 (0.42%)
  custom_event_name: z.string().nullable(),
  // undefined: 216_038 (67.13%), defined 105_792 (32.87%)
  filter_description: z.string().optional(),
  // undefined: 216_038 (67.13%), defined 105_792 (32.87%)
  filters: triggerFiltersGetSchema.optional(),
  // null: 22_245 (6.91%)
  // true 3_771 (1.26%), false 295_814 (98.74%)
  hard_deleted: z.boolean().nullable().optional(),
});
